import React, {useEffect} from "react";
import {TypeAnimation} from "react-type-animation";
import AOS from "aos";
import "aos/dist/aos.css";

function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({duration: 800, once: true});
    }, []);

    return (
        <div className="container py-5">
            {/* About Us Section */}
            <div className="row align-items-center mb-5" data-aos="fade-up">
                <div className="col-md-6">
                    <h1 className="display-5 fw-bold mb-4 text-success">
                        <TypeAnimation
                            sequence={[
                                "About Us", 2000,
                                "Who We Are", 2000,
                                "InOutTek Solutions", 2000,
                            ]}
                            wrapper="span"
                            speed={50}
                            repeat={Infinity}
                        />
                    </h1>
                    <p className="fs-5 text-start text-muted">
                        InOutTek Solutions. We specialize in delivering tailored software development, IT consulting,
                        and cloud solutions designed to meet the unique needs of our clients. With a team of experienced
                        professionals, we are committed to excellence in every project, ensuring that our clients
                        achieve their goals through cutting-edge technology and strategic insights.
                    </p>
                </div>
                <div className="col-md-6 text-center" data-aos="zoom-in">
                    <img
                        src="../images/About/aboutus.jpg"
                        alt="About InOutTek"
                        className="img-fluid rounded "
                        style={{maxWidth: "70%"}}
                    />
                </div>
            </div>

            {/* Services Section */}
            <div className="row align-items-center my-5 pb-5 flex-md-row-reverse" data-aos="fade-left">
                <div className="col-md-6">
                    <h2 className="h1 fw-bold mb-4 text-primary" >Our Services</h2>
                    <p className="fs-5 text-muted text-start">
                        At InOutTek Solutions, we specialize in delivering top-notch software development services that
                        empower businesses to thrive in the digital age. Our offerings includes.Tailored software
                        solutions designed to meet the specific needs and goals of your business.Implementing scalable
                        cloud-based applications and services that enhance flexibility and reduce costs.Designing and
                        integrating APIs to connect systems, enabling smooth data exchange and functionality.Offering
                        ongoing support to ensure your software remains up-to-date, secure, and performing at its best.
                    </p>

                </div>
                <div className="col-md-6 text-center" data-aos="zoom-in">
                    <img
                        src="../images/About/aboutServices.jpg"
                        alt="Our Services"
                        className="img-fluid rounded shadow"
                        style={{maxWidth: "100%"}}
                    />
                </div>
            </div>

            {/* Internship Section */}
            <div className="row align-items-center mt-5 shadow  rounded-3" data-aos="flip-right">
                <div className="col-md-6 ps-md-5 p-4">
                    <h2 className="fw-bold mb-3 text-info">Beyond Software</h2>
                    <p className="text-muted fs-5 text-start">
                        InOutTek Solutions offers an engaging internship program tailored for college students, which
                        aims to provide hands-on experience in several tech domains, such as<strong> DevOps, Full Stack
                        Development, and Release Engineering.</strong> This free internship program is designed to
                        support and
                        develop future tech talent, offering practical project work and mentorship to equip students
                        with real-world skills.
                    </p>
                </div>

                <div className="col-md-6 mb-4 mb-md-0">
                    <img
                        src="../images/About/intrenships.jpg"
                        alt="Internships"
                        className="img-fluid rounded-4 "
                        style={{width: '90%'}}
                    />
                </div>
            </div>
        </div>
    );
}

export default About;
